import axios, { AxiosResponse } from 'axios';

import { ETypTransakce } from 'enums/specialniSluzby/typTransakce';

export interface ISouborPolozka {
    pocetcp: number;
    ucet: string;
    idnabyvatele?: string;
    koducastnika?: string;
    cislozastavnismlouvy: string;
    poznamka: string;
    zdrojdat: string;
    zpusobporizeni: string;
    typtransakce?: ETypTransakce;
    upozorneni: string;
    stav: string;
    lzeevidovatod?: string;
    idvlastnika?: string;
    prijmeni?: string;
    jmeno?: string;
}

export interface INacteni {
    id: number;
    isin: string;
    datum: string;
    nazevdavky: string;
    nazeverror: string;
    kontrolapocet: string;
    sezpozbezchyby: {
        polozky: ISouborPolozka[];
    };
    sezpozchybnych: {
        polozky: ISouborPolozka[];
    };
}

interface IDataNacteni {
    id?: number;
    file: string;
    nazev: string;
}

interface IDataZapis {
    id?: number;
    file: string;
    nazev: string;
}

export interface IVystupCSV {
    redirect: string;
}

interface IDataVystupCSV {
    id?: number | string;
    idpolozky?: number | string;
    ucet?: string;
    idnabyvatele?: string;
    koducastnika?: string;
    zdrojdat?: string;
    zpusobpor?: string;
    zpusobporizeni?: string;
    idvcdcp?: string;
    pocetcp?: string;
    idvlastnika?: string;
    jmeno?: string;
    prijmeni?: string;
    zastsmlouva?: string;
    typtransakce?: ETypTransakce;
    stav?: string;
    file?: string;
    sankce?: boolean;
    rliv?: string;
}

/* Načte údaje pro zadání požadavku ze souboru */
export const ueSouborNacteni = (id: number, data: IDataNacteni, dlt?: boolean) => {
    return axios({
        method: 'GET',
        url: `/${dlt ? 'UED' : 'UE'}/${id}/soubor/nacteni`,
        params: {
            file: data.file,
            nazev: data.nazev
        }
    }).then((resp: AxiosResponse<INacteni>) => resp.data);
};

/* Hromadně založí bezchybné položky požadavku ze souboru */
export const ueZalozeni = (id: number, data: IDataZapis, dlt?: boolean) => {
    return axios({
        method: 'POST',
        url: `/${dlt ? 'UED' : 'UE'}/${id}/soubor/zapis`,
        params: {
            file: data.file,
            nazev: data.nazev
        }
    }).then((resp: AxiosResponse) => resp.data);
};

/* Vrátí CSV soubor k položkám požadavku */
export const ueSouborVystupCSV = (id: string | number, data: IDataVystupCSV, dlt?: boolean) => {
    return axios({
        method: 'GET',
        url: `/${dlt ? 'UED' : 'UE'}/${id}/soubor/vystupcsv`,
        params: {
            ...data
        }
    }).then((resp: AxiosResponse<IVystupCSV>) => resp.data);
};
